module.exports = __webpack_public_path__ + "assets/note-book.519e8345.svg";